import { z } from 'zod';

/**
 * 会計区分フォームのバリデーションスキーマ（作成・編集共通）
 *
 * 制約値は MasterAccountingTypeCreateRequest / MasterAccountingTypePatchRequest の OpenAPI 定義に準拠
 */
export const accountingTypesSchema = z.object({
  code: z.string().min(1).max(50),
  name: z.string().min(1).max(255),
  year: z.string().min(1),
});

export type AccountingTypesFormValues = z.infer<typeof accountingTypesSchema>;
